import React from "react";
import "./App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { MessageCircle } from "lucide-react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import MobileNav from "./components/MobileNav";
import Home from "./pages/Home";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Admin from "./pages/Admin";
import { CartProvider } from "./context/CartContext";
import { Toaster } from "./components/ui/toaster";
import { WA_NUMBER } from "./mock";

const Layout = () => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <>
      {!isAdmin && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/produk/:id" element={<ProductDetail />} />
        <Route path="/keranjang" element={<Cart />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      {!isAdmin && <Footer />}
      {!isAdmin && <div className="h-24 md:hidden" />}
      <MobileNav />

      {!isAdmin && (
        <a
          href={`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(
            "Halo ruangrasa! Saya mau bertanya tentang produk."
          )}`}
          target="_blank"
          rel="noopener noreferrer"
          className="hidden md:flex fixed bottom-24 right-4 md:bottom-6 md:right-6 z-50 w-14 h-14 bg-[#0B7C6E] hover:bg-[#096A5E] rounded-full items-center justify-center shadow-xl shadow-green-600/40 hover:-translate-y-1 hover:scale-105 transition-all duration-300"
          aria-label="Chat WhatsApp"
        >
          <MessageCircle className="w-6 h-6 text-white" />
        </a>
      )}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <Layout />
          <Toaster />
        </BrowserRouter>
      </CartProvider>
    </div>
  );
}

export default App;
